import React from "react";

function Inbox() {
  return <div>Inbox</div>;
}

export default Inbox;
